import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Emails } from 'app/components/models/hrwemodel';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-new-report-request',
  templateUrl: './new-report-request.component.html',
  styleUrls: ['./new-report-request.component.css']
})
export class NewReportRequestComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  data: any;
  newReportRequestForm: FormGroup;
  emails: Emails[] = [];
  dataJSON: any;
  aggiungi = false;
  minDate: any;
  emailValidate: boolean = false;
  modalReference: any;

  constructor(
    private commonUtilService: CommonUtilService,
    private reportService: ReportService,
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    public datepipe: DatePipe,
    private spinnerService: SpinnerService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.NEW_REPORT")

    this.minDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

    this.newReportRequestForm = this.newReportRequestFormBuilder(this.formBuilder);

    this.reportService.initReport().subscribe(data => {
      console.log(data);
      this.data = data;
      this.newReportRequestForm = this.newReportRequestFormBuilder(this.formBuilder);

      this.addCandidate();

      this.newReportRequestForm.get('elenco_email').valueChanges.subscribe(values => {

        this.emails = [];
        const ctrl = <FormArray>this.elencoEmail;

        ctrl.controls.forEach(x => {
          this.emails.push({
            email: x.get('emailAddress').value,
          });
          this.changeDetector.detectChanges();
        });
        this.spinnerService.stop();
      });
    });

  }

  get f() { return this.newReportRequestForm.controls; }

  get val() { return this.newReportRequestForm.value; }

  newReportRequestFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      requestNumber: [this.data && this.data.requestNumber ? this.data.requestNumber : '', [Validators.required]],
      referencePerson: ['', [Validators.required]],
      elenco_email: formBuilder.array([]),
      validEndDate: ['', [Validators.required]]
    });
  }

  addCandidate() {
    this.spinnerService.start();
    this.emailValidate = false;
    this.elencoEmail.push(this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]]
    }));
    this.spinnerService.stop();
  }

  deleteCandidate(index) {
    this.spinnerService.start();
    this.elencoEmail.removeAt(index);
    this.spinnerService.stop();
  }

  get elencoEmail() {
    return this.newReportRequestForm.get('elenco_email') as FormArray;
  }

  onSubmit() {
    this.spinnerService.start();
    this.success = false;
    this.error = false;
    this.submitted = true;
    this.emailValidate = true;

    if (this.newReportRequestForm.invalid) {

      this.commonUtilService.findInvalidControls(this.newReportRequestForm);
      this.spinnerService.stop();
      return;
    }

    if (this.emails.length !== 0) {

      let eRes = [];
      for (var val of this.emails) {
        eRes.push(val.email);
      }

      this.dataJSON = {
        requestNumber: this.val.requestNumber,
        referencePerson: this.val.referencePerson,
        validEndDate: this.val.validEndDate,
        emailAddresses: eRes
      };

      this.reportService.createReport(this.dataJSON).subscribe(data => {

        console.log(data);

        this.success = true;
        this.spinnerService.stop();

        setTimeout(() => { this.goToReportHistory(); }, 2);

      }, err => {
        this.error = true;
        this.spinnerService.stop();
        setTimeout(()=>{                           
          this.error = false;
        }, 2000);
      });

    }
  }

  goToReportHistory() {
    this.spinnerService.start();
    this.router.navigate(['/report/report-history']);
  }

  getConfirmation() {
    this.success = false;
    this.error = false;
    this.submitted = true;
    this.emailValidate = true;

    if (this.newReportRequestForm.invalid) {

      this.commonUtilService.findInvalidControls(this.newReportRequestForm);
      this.spinnerService.stop();
      return;
    }

    let modalElem = <HTMLInputElement>document.querySelector("#launchModal");
    modalElem.click();
  }

  open(content) {
    this.modalReference = this.modalService.open(content);
    this.modalReference.result.then((result) => {
      if (result === '1') {
        this.onSubmit();
      }
      this.modalReference.close();
    });

  }

}
